import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import AS from "./Service/Authentication";
import FireDetection from "../Layout/provider/FireDetection";
import { ROUTES } from "../../commons/constants/routes/routes";

// ROLE_ORG 사용자 접근 허용 경로
const ORG_ALLOWED_PATHS = [ROUTES.DASHBOARD.MAIN, ROUTES.LOGOUT];

class AuthenticatedRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (AS.isUserLoggedIn()) {
      document.body.className = "";
      const { root, path } = this.props;
      const { params } = this.props.computedMatch;
      // ROLE_ORG 사용자는 대시보드(+ 로그아웃)만 접근 가능, 그 외 경로는 대시보드로 이동
      if (AS.hasAuthority("ROLE_ORG") && !ORG_ALLOWED_PATHS.includes(path)) {
        return <Redirect to={ROUTES.DASHBOARD.MAIN} />;
      }
      // switch (root) {
      //     case "plant":
      //         if (AS.isAuthPlant(params.plantId)) {
      //             return <Route {...this.props}/>
      //         } else {
      //             alert("권한이 없습니다.");
      //             return <Redirect to="/"/>;
      //         }
      //     default:
      //         return <Route {...this.props}/>
      // }
      return (
        <FireDetection>
          <Route {...this.props} />
        </FireDetection>
      );
    } else {
      return <Redirect to={ROUTES.LOGIN} />;
    }
  }
}

export default AuthenticatedRoute;
